import React, {useState, useEffect, useRef} from "react";
import {Card, CardBody, Container, Row, Col} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Pagination} from "antd";
import Select from "react-select"; // Adicionado import para Select

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import UsersSearch from "../dashboard/calender/UsersSearch";
import CustomPagination from "../util/CustomPagination";
import SpecialtiesUserModal from "./SpecialtiesUserModal";
import SpecialtiesEditModal from "./SpecialtiesEditModal";
import SpecialtiesUserListModal from "./SpecialtiesUserListModal";
import AddUserToSpecialtyModal from "./AddUserToSpecialtyModal";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import DropdownPortal from "../util/DropdownPortal";
import AuthService from "../util/AuthService"; // estilo base
const SpecialtiesPage = () => {
    document.title = "Especialidades | Plantão Rápido";
    const user = AuthService.getUserData();

    const buttonRefs = useRef({});
    const [dropdownOpenId, setDropdownOpenId] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const refUserSearch = useRef(null);
    const [specialtyOptions, setSpecialtyOptions] = useState([]);
    const [specialtys, setSpecialtys] = useState([]);
    const [specialty, setSpecialty] = useState(null);
    const selectInputRef = useRef();
    const [filters, setFilters] = useState({
        status: null,
        user_id: '',
        specialties: [],
    });

    const options = [
        {value: "S", label: "Ativo"},
        {value: "N", label: "Inativo"},
    ];

    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [showspecialtyModal, setShowspecialtyModal] = useState(false);
    const [showspecialtyUserModal, setShowspecialtyUserModal] = useState(false);
    const [showspecialtyUserListModal, setShowspecialtyUserListModal] = useState(false);
    const [loadingspecialty, setLoadingspecialty] = useState(false);


    const fetchSpecialties = async () => {
        try {
            const storedSpecialties = localStorage.getItem("specialties-select");

            if (storedSpecialties) {
                setSpecialtyOptions(JSON.parse(storedSpecialties));
            } else {
                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}specialties/list`);

                const {data} = ApiService.handleApiResponse(response);

                const options = data.map(specialty => ({
                    value: specialty.id,
                    label: specialty.name,
                }));
                localStorage.setItem("specialties-select", JSON.stringify(options));
                setSpecialtyOptions(options);
            }
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    useEffect(() => {
        fetchspecialty();
        fetchSpecialties();
    }, []);


    const fetchspecialty = async (page = 1) => {
        try {
            setLoadingspecialty(true);

            const param = {
                pagination: pagination.pageSize,
                page: page,
                user_id: filters?.user_id || null,
                status: filters?.status?.value || null,
                specialties: filters?.specialties || []
            };

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}specialties/list-specialties`,
                param,
                true
            );

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setSpecialtys(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingspecialty(false);
        }
    };
    const handleChange = (selectedOption) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: selectedOption,
        }));
    };
    const handleClearFilters = () => {
        setFilters({
            status: null,
            user_id: null,
            specialty: null,
        });

        // Chamar a função clearHospital() no HospitalSearch
        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }
    };

    const handlespecialtyModalClose = (save = false) => {
        setShowspecialtyModal(false);
        if (save) {
            fetchspecialty(pagination.current);
        }
    };

    const handlespecialtyUserModalClose = () => {
        setShowspecialtyUserModal(false);
        setSpecialty(null);
    };

    const handlespecialtyUserListModalClose = () => {
        setShowspecialtyUserListModal(false);
        setSpecialty(null);
    };


    const handleModalEdit = (specialty = null) => {
        setSpecialty(specialty);
        setShowspecialtyModal(true);
    }


    const handlespecialtyUserModal = (specialty = null) => {
        setSpecialty(specialty);
        setShowspecialtyUserListModal(true);
    }
    const handleSpecialty = (specialty = null) => {
        setSpecialty(specialty);
    }


    const handleModalUser = (specialty) => {
        setShowspecialtyUserModal(true);
    }

    const handlePageChange = (page) => {
        fetchspecialty(page);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Especialidades" pageTitle="Configuração"/>
                    <Row>
                        <div className="row mt-12 mb-12">
                            {/*<div className="col-md-4">*/}
                            {/*    <div className="form-group">*/}
                            {/*        <label>Situação</label>*/}
                            {/*        <Select*/}
                            {/*            key={filters.status ? "has-value" : "no-value"} // Altera a key ao limpar*/}
                            {/*            options={options}*/}
                            {/*            value={filters.status} // Garante que o valor seja atualizado corretamente*/}
                            {/*            onChange={handleChange}*/}
                            {/*            placeholder="Selecione"*/}
                            {/*            isClearable*/}
                            {/*            styles={{*/}
                            {/*                control: (provided) => ({*/}
                            {/*                    ...provided,*/}
                            {/*                    width: '100%',*/}
                            {/*                }),*/}
                            {/*            }}*/}
                            {/*        />*/}

                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="col-md-6">
                                <UsersSearch
                                    ref={refUserSearch}
                                    onUserSelect={(user) =>
                                        setFilters((prevFilters) => ({
                                            ...prevFilters,
                                            user_id: user?.value || "",
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-md-6 form-group">
                                <label>Especialidades</label>
                                <Select
                                    isMulti
                                    ref={selectInputRef}
                                    value={filters.specialties || []}
                                    onChange={(selectedOptions) =>
                                        setFilters({
                                            ...filters,
                                            specialties: selectedOptions || []
                                        })
                                    }
                                    options={specialtyOptions}
                                    placeholder="Selecione"
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({...base, zIndex: 9999}),
                                        menu: base => ({...base, zIndex: 9999}),
                                    }}
                                />


                            </div>

                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12 d-flex justify-content-end">

                                <button type="button" className="btn  mr-1  me-2"
                                        onClick={() => handleClearFilters()}>
                                    <i className="fa fa-eraser"></i> Limpar Filtros
                                </button>

                                <button type="button" className="btn btn-info mr-1  me-2"
                                        onClick={() => handleModalUser()}>
                                    <i className="fa fa-plus"></i> Vincular por Plantonista
                                </button>

                                {(user?.users_type_id === 7) && (
                                    <button type="button" className="btn btn-info mr-1  me-2"
                                            onClick={() => handleModalEdit()}>
                                        <i className="fa fa-plus"></i> Cadastrar
                                    </button>
                                )}

                                <button type="button"
                                        className="btn btn-success"
                                        onClick={() => fetchspecialty(1)}
                                        disabled={loadingspecialty}
                                >
                                    {loadingspecialty ? (
                                        <>
                                                    <span className="spinner-border spinner-border-sm me-2"
                                                          role="status" aria-hidden="true"></span>
                                            Buscando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search me-2"></i> Buscar
                                        </>
                                    )}
                                </button>

                            </div>
                        </div>


                        {/* Lista de Funcionários */}
                        <div className="list-container mt-4">
                            {loadingspecialty ? (
                                <Skeleton count={5} height={120}/>
                            ) : specialtys.length > 0 ? (
                                specialtys.map((specialty) => (
                                    <Col lg={12} key={specialty.id}>
                                        <Card className="mb-1 p-2 shadow-sm card-hover">
                                            <CardBody
                                                className="card-body d-flex justify-content-between align-items-center p-2">

                                                <div className="col-6 ">
                                                    <h5 className="doc-name">{specialty?.name || "Usuário não identificado"}</h5>


                                                    <p className="text-muted mb-1">
                                                        <i className="fa fa-file-text-o text-info me-2"></i>
                                                        {specialty?.description ? specialty.description : "Descrição não informada"}
                                                    </p>


                                                </div>
                                                <h6 className="text-muted mb-1">
                                                    <i className="fa fa-user me-2"></i>
                                                    {specialty.user_count}
                                                </h6>
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-outline-info btn-sm me-5"
                                                        type="button"
                                                        ref={(el) => (buttonRefs.current[specialty.id] = el)}
                                                        onClick={() =>
                                                            setDropdownOpenId(dropdownOpenId === specialty.id ? null : specialty.id)
                                                        }
                                                    >
                                                        <i className="fa fa-ellipsis-v"></i> Opções
                                                    </button>

                                                    <DropdownPortal
                                                        parentRef={{current: buttonRefs.current[specialty.id]}}
                                                        show={dropdownOpenId === specialty.id}
                                                        onClose={() => setDropdownOpenId(null)}
                                                    >
                                                        <ul className="dropdown-menu show">
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        handlespecialtyUserModal(specialty);
                                                                        setDropdownOpenId(null);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-user me-2"></i> Listar
                                                                    Plantonista
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        handleSpecialty(specialty);
                                                                        setShowAddModal(true);
                                                                        setDropdownOpenId(null);
                                                                    }}
                                                                >
                                                                    <i className="fa fa-plus me-2"></i> Adicionar
                                                                    Plantonista
                                                                </button>
                                                            </li>
                                                        </ul>

                                                    </DropdownPortal>
                                                </div>


                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <div className="text-center">
                                    <div className="alert alert-primary" role="alert">Nenhuma especialidade
                                        encontrada.
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Paginação */}
                        <CustomPagination
                            onChange={handlePageChange}
                            pagination={pagination}
                        />


                        {showspecialtyModal && (
                            <SpecialtiesEditModal
                                show={showspecialtyModal}
                                onHide={handlespecialtyModalClose}
                                specialty={specialty}
                            />
                        )}
                        {showspecialtyUserModal && (
                            <SpecialtiesUserModal
                                show={showspecialtyUserModal}
                                onHide={handlespecialtyUserModalClose}
                                specialty={specialty}
                            />
                        )}
                        {showspecialtyUserListModal && (
                            <SpecialtiesUserListModal
                                show={showspecialtyUserListModal}
                                onHide={handlespecialtyUserListModalClose}
                                specialty={specialty}
                            />
                        )}
                        {showAddModal && (
                            <AddUserToSpecialtyModal
                                show={showAddModal}
                                onHide={() => setShowAddModal(false)}
                                specialty={specialty}
                                onSuccess={() => fetchspecialty(1)}
                            />
                        )}

                    </Row>
                </Container>
            </div>
        </React.Fragment>

    );
};

export default SpecialtiesPage;
